import { defineStore } from "pinia";

export const useSessionStore = defineStore("sessionStore", {
    state: () => {
        return {
            searchState: {
                hits: [],
                filters: null,
                query: '',
                scrollY: 0,
                url: '',
            },
            userStore: {
                hasStore: false,
                storeDC: '',
                storeNum: '',
                storePhone: '',
                storePhoneLink: '',
                freezerClosed: false,
                freezerClosedCase: false,
                freezerClosedMessage: ''
            },
            userFavorites: {
                favoritesList: ''
            },
            userCartItems: {
                usfitem: {
                   itemQty: 0,
                   caseQty: 0 
                }
            },
            departments: {
                department: '',
                deptName: ''
            },
            expiredItems: {},
            appId: '',
            apiKey: '',
            appIdStag: '',
            apiKeyStag: '',
            environment: '',
            index: '',
            indexStag: '',
            storeNum: '',
            isAvibe: false,
            lastQueryID: null,
            trackAlgolia: true,
            imgix: false,
            userToken: '',
            authUserToken: '',
            hasStore: false
        }
    },
    actions: {
        async getUserStore() {
            try{
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=getUserStore",
                    {
                        method: "POST"
                    }
                );
        
                if (response.ok) {
                    let result = await response.json();

                    this.userStore = result.data.userStore;
                    this.userStore.storeDC = this.userStore.storeDC;
                    this.userStore.storeNum = this.userStore.storeNum.toString();
                }
            } catch (error) {

            }
        },
        async getUserFavorites() {
            try {
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=getUserFavorites",
                    {
                        method: "POST"
                    }
                );
        
                if(response.ok) {
                    let result = await response.json();

                    this.userFavorites = result.data.userFavorites;
                }
            } catch (error) {

            }
            
        },
        async getUserCartItems() {
            try{
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=getUserCartItems",
                    {
                        method: "POST"
                    }
                );
        
                if (response.ok) {
                    let result = await response.json();

                    this.userCartItems = result.data.userCartItems;
                }
            } catch (error) {

            }
        },
        async getDepartments() {
            try {
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=getDepartments",
                    {
                        method: "POST"
                    }
                );
        
                if(response.ok) {
                    let result = await response.json();

                    this.departments = result.data.departments;
                }
            } catch (error) {

            }
            
        },
        async setQueryID(queryID, position) {
            try {
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=setQueryID&queryID=" + queryID + "&position=" + position,
                    {
                        method: "POST"
                    }
                );
        
                if(response.ok) {
                    this.lastQueryID = queryID;
                }
            } catch (error) {

            }
        },
        async setSearchState(hitCount, filters, query, scrollY, url) {
            if(hitCount === undefined) hitCount = 0;
            if(filters === undefined) filters = null;
            if(query === undefined) query = '';
            if(scrollY === undefined) scrollY = 0;
            if(url === undefined) url = '';

            try {
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=setSearchState",
                    {
                        method: "POST",
                        body: new URLSearchParams({
                            hitCount: hitCount,
                            filters: JSON.stringify(filters),
                            query: query,
                            scrollY: scrollY,
                            url: url
                        })
                    }
                );
            } catch (error) {
                
            }
        },
        async getSearchState() {
            try {
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=getSearchState",
                    {
                        method: "POST"
                    }
                );

                if (response.ok) {
                    let result = await response.json();
                    
                    if ({'getSearchState': result.data}) {
                        this.searchState.hitCount = result.data.HITCOUNT || 0;
                        this.searchState.filters = result.data.SEARCHFILTERS ? JSON.parse(result.data.SEARCHFILTERS) : [];
                        this.searchState.query = result.data.SEARCHQUERY || '';
                        this.searchState.scrollY = result.data.SCROLLY || 0;
                        this.searchState.url = result.data.URL || '';
                    }
                }
            } catch (error) {
                
            }
        },
        async getExpiredItems() {
            try {
                let response = await fetch(
                    "/controller/algoliaAPI.cfc?method=getExpiredItems",
                    {
                        method: "POST"
                    }
                );

                if(response.ok) {
                    let result = await response.json();
                    let expiredItems = result?.data?.expiredItems;
                    this.expiredItems = expiredItems && typeof expiredItems === 'object' && !Array.isArray(expiredItems)
                        ? expiredItems
                        : {};
                }
            } catch (error) {

            }
            
        }
    },
})